
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#000","fill-opacity":".87","d":"M14.53 5l1.06 2.4-4.09 4.1a.708.708 0 00.292 1.236.71.71 0 00.708-.236l4.1-4.09L19 9.47a.93.93 0 00.94-.22l2.82-2.82a.91.91 0 00-.35-1.51l-2.47-.83-.83-2.47a.911.911 0 00-.89-.62.943.943 0 00-.65.27l-2.82 2.82a.92.92 0 00-.22.91z"}}),_c('path',{attrs:{"fill":"#FAB4CD","d":"M18 2.85l.56 1.69.23.67.67.23 1.69.56-1.99 2-2.18-.98-.97-2.18z"}}),_c('path',{attrs:{"fill":"#FAB4CD","d":"M22.49 8.68l-1.16 1.16a9.6 9.6 0 11-7.17-7.17l1.16-1.16a11 11 0 107.171 7.17z"}}),_c('path',{attrs:{"fill":"#000","fill-opacity":".87","d":"M13.18 5.47a2.674 2.674 0 01-.11-.64 7.522 7.522 0 00-1.07-.1A7.27 7.27 0 1019.27 12a7.662 7.662 0 00-.1-1.08 2.612 2.612 0 01-.64-.1l-.92-.41a5.99 5.99 0 01.24 1.59 5.851 5.851 0 01-11.7 0c0-3.23 2.62-5.85 5.85-5.85a5.99 5.99 0 011.59.24c-.43-1-.37-.82-.41-.92z"}}),_c('path',{attrs:{"fill":"#FAB4CD","d":"M12 8.45A3.55 3.55 0 1015.55 12a3.837 3.837 0 00-.05-.49l-2 2a2.081 2.081 0 01-1.5.63A2.14 2.14 0 019.87 12a2.081 2.081 0 01.63-1.5l2-2a3.975 3.975 0 00-.5-.05z"}})])])
          )
        }
      }
    